import {Grid, TextField as MUITextField, Typography,} from "@mui/material";
import {UseFormReturn} from "react-hook-form";
import {ControlledTextField} from "src/components/forms";
import {FormOperacionControlOperativo} from "../types/types";
import {OperacionControlOperativoFields} from "../types/fields";
import {dateFormatter} from "src/utils/formatters";
import {OperacionControlOperativoViewDTO} from "../types/dto";

type DatosOperacionProps = {
  formMethods: UseFormReturn<FormOperacionControlOperativo>
  readOnly?: boolean
  operacion?: OperacionControlOperativoViewDTO
  codSistemaPrincipal: number
  nuevo?: boolean
}

const SeccionControlOperativoDatosOperacion = ({
                                                 formMethods,
                                                 readOnly,
                                                 operacion,
                                                 codSistemaPrincipal,
                                                 nuevo
                                               }: DatosOperacionProps) => {

  const {control, watch} = formMethods

  return (
    <Grid container xs={12} spacing={4}>
      {
        !nuevo &&
          <Grid item xs={12} md={3}>
              <Typography variant='body2'>Responsable</Typography>
              <Typography>{operacion && `${operacion?.[OperacionControlOperativoFields.Responsable]}`}</Typography>
          </Grid>
      }

      {
        readOnly ? (
            <Grid item xs={12} md={3}>
              <Typography variant='body2'>Fecha Carga</Typography>
              <Typography>{operacion ? dateFormatter.toShortDate(operacion?.[OperacionControlOperativoFields.FechaCarga]) : '-'}</Typography>
            </Grid>
          ) :
          <Grid item xs={12} md={3}>
            <MUITextField
              label={'Fecha de Carga'}
              value={watch(OperacionControlOperativoFields.FechaCarga) ? dateFormatter.toShortDate(watch(OperacionControlOperativoFields.FechaCarga)) : '-'}
              disabled
              fullWidth
            />
          </Grid>
      }

{/*      <Grid item xs={12} md={3}>
        {
          readOnly ?
            <>
              <Typography variant='body2'>Responsable</Typography>
              <Typography>{operacion && `${operacion[OperacionControlOperativoFields.Responsable]}`}</Typography>
            </> :
            <>
              <MUITextField
                label={'Responsable'}
                value={watch(OperacionControlOperativoFields.Responsable) || '-'}
                fullWidth
                disabled
              />
            </>
        }
      </Grid>*/}

    </Grid>
  )
}

export default SeccionControlOperativoDatosOperacion;